import fullscreenAPI from "../utils/fullscreen-api"
import { hideEndDisplay } from "./end-display"
import { isMobile, isTouchDevice } from "../utils/breakpoints"
import { isPlayerInCSSFullscreen, isPlayerInFullscreen } from "./player-fullscreen-util"
import { isPresentation } from "./presentation-types"
import { cssFullscreenOverlayBackdrop, fullscreenOverlay, player, slideContainer, toolbar } from "./selectors"
import logEvent from "../tracking/amplitude/log-event"

const enterAPIFullscreen = () => {
  hideEndDisplay()
  player.addClass("fullscreen")
  toolbar.hide()
  fullscreenAPI.requestNativeFullscreen(player[0])
}

const exitAPIFullscreen = () => {
  hideEndDisplay()
  player.removeClass("fullscreen")
  fullscreenOverlay.hide()
  toolbar.show()
  if (fullscreenAPI.isFullscreen) {
    fullscreenAPI.exitNativeFullscreen()
  }
}

const toggleFullscreenOverlay = () => {
  if (fullscreenOverlay.is(":visible")) {
    fullscreenOverlay.hide()
  } else {
    fullscreenOverlay.show()
  }
}

const handlePresentationsInLandscape = () => {
  if (window.orientation === 90 && isPresentation() && isMobile() && isPlayerInCSSFullscreen()) {
    slideContainer.css("max-height", "")
    slideContainer.css("min-height", "")
    player.css("height", window.innerHeight + "px")
    slideContainer.css("max-height", window.innerHeight + "px")
    slideContainer.css("min-height", window.innerHeight - 1 + "px")
  }
}

const enterCSSFullscreen = () => {
  $(
    "header#main-nav, .dwnld-btn-pos-right, .slideshow-info-container, .content-page-full-width, footer#modernize-footer"
  ).hide()
  toolbar.hide()
  player.addClass("fullscreen-css")
  cssFullscreenOverlayBackdrop.show()
  $("body").addClass("player-css-fullscreen")
  player.css("height", window.innerHeight + "px")
  handlePresentationsInLandscape()
}

const exitCSSFullscreen = () => {
  $(
    "header#main-nav, .dwnld-btn-pos-right, .slideshow-info-container, .content-page-full-width, footer#modernize-footer"
  ).show()
  toolbar.show()
  player.removeClass("fullscreen-css")
  cssFullscreenOverlayBackdrop.hide()
  $("body").removeClass("player-css-fullscreen")
  fullscreenOverlay.hide()
  player.css("height", "unset")
}

export const enterFullscreen = () => {
  if (isMobile() && isTouchDevice()) {
    enterCSSFullscreen()
  } else if (fullscreenAPI.isFullscreenModeSupported && !fullscreenAPI.isFullscreen) {
    enterAPIFullscreen()
  }

  logEvent("slideshow_fullscreen_click", { click_type: "open" })
}

export const exitFullscreen = () => {
  if (isMobile() && isTouchDevice()) {
    exitCSSFullscreen()
  } else if (fullscreenAPI.isFullscreenModeSupported && fullscreenAPI.isFullscreen) {
    exitAPIFullscreen()
  }

  logEvent("slideshow_fullscreen_click", { click_type: "close" })
}

export const initializeFullscreen = () => {
  $("button#fullscreen").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    enterFullscreen()
  })

  $("#exit-fullscreen").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    exitFullscreen()
  })

  $("#new-player").on("click", function () {
    if (isPlayerInFullscreen()) {
      toggleFullscreenOverlay()
    }
  })

  // handle player height on orientation change
  window.addEventListener("resize", function (e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.orientation === 0 || window.orientation === 90) {
      if (isPlayerInCSSFullscreen()) {
        if (isMobile() && isTouchDevice()) {
          player.css("height", window.innerHeight + "px")
          handlePresentationsInLandscape()
        } else {
          /**
           * Screen size in portrait mode is mobile (less than 928px),
           * landscape mode screen size is greater than 928px
           */
          exitCSSFullscreen()
          enterFullscreen()
        }
      }
    }
  })

  fullscreenAPI.addEventListener("fullscreenchange", () => {
    // After a keyboard-triggered exit event, isFullscreen will return false
    if (!fullscreenAPI.isFullscreen) {
      exitAPIFullscreen()
    }
  })
}
